import { createApp } from 'vue';
// import { currentInstance } from 'Resources/currentInstance.js';

import Vuex from 'vuex';
// currentInstance.use(Vuex);
createApp(Vuex);

// Modules
import auth from "./modules/auth";
import cache from "./modules/cache";
import branch from "./modules/branch";

export default new Vuex.Store({
    modules: {
        auth,
        cache,
        branch
    },
    strict: true
})